module.exports = __webpack_public_path__ + "c316f24ef6cc8ecc3e832f17cd4ba7e7.pdf";